<template>
    <div class="card shadow-sm">
        <!-- Placeholder if Kiss Video not available -->
        <img class="card-img-top rounded" :src="post.thumbnail_url" @load="imageLoaded = true"/>

        <!-- Loading indicator if image is not loaded -->
        <div class="text-center bg-light" v-if="!imageLoaded" style="padding-top: 80px; padding-bottom: 80px;">
            <i class="mdi mdi-spin mdi-autorenew mdi-36px text-primary"></i>
        </div>

        <div class="card-body">
            <h3 class="oswald">
                {{ post.title }}
            </h3>
            <div>
                <span class="badge badge-primary badge-sm" v-if="isNew">
                    {{ $t('pages.locker.my_blog.new') }}
                </span>
                <span class="text-muted font-weight-bolder mt-2 text-small">
                    {{ $date(post.creted_at).format('DD.MM.YYYY') }}
                </span>
            </div>

            <p class="mt-4 text-secondary">
                {{ post.contents_preview }}
            </p>

            <div class="mt-5">
                <router-link :to="{name: 'locker.my-blog.view', params: {slug: post.slug}}" class="btn btn-outline-dark">
                    {{ $t('pages.locker.my_blog.read_more') }}
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "BlogPostCard",
    data: () => ({
        imageLoaded: false,
    }),
    props: {
        post: {
            type: Object,
            required: true
        }
    },
    computed: {
        isNew() {
            let timeNow = this.$date();
            let releaseTime = this.$date(this.post.created_at);

            return timeNow.diff(releaseTime, "hour") <= 24;
        }
    }
}
</script>

<style scoped>

</style>
